import _ from 'lodash';

import type { EditorAPI } from '#packages/editorAPI';
import { fontUtils } from '#packages/textControls';

export function getMissingFontName(
  fontFamily: string | undefined,
  editorAPI: EditorAPI,
): string {
  if (!fontFamily) {
    return '';
  }

  if (fontUtils.isUploadedFont(fontFamily)) {
    let originalFontName = fontFamily.split(',')[2];
    if (originalFontName) {
      originalFontName = originalFontName.replace('orig_', '');
      originalFontName = _.startCase(originalFontName);
      return originalFontName;
    }
  }

  const fontFamilyFixed = fontFamily.replace(/["']/g, '');
  const familiesMap = getFontFamiliesMap(editorAPI);

  if (familiesMap.has(fontFamilyFixed)) {
    return familiesMap.get(fontFamilyFixed);
  }

  return _.startCase(fontFamilyFixed.replaceAll(/[-+]/g, ' '));
}

let allFontsFamilyNameToDisplayNameMap: Map<string, string> | undefined;

function getFontFamiliesMap(editorAPI: EditorAPI): Map<string, string> {
  if (!allFontsFamilyNameToDisplayNameMap) {
    allFontsFamilyNameToDisplayNameMap = fontUtils
      .getCurrentSelectableFontsWithParams(editorAPI, true, true)
      .flatMap((it) => it.fonts)
      .reduce((acc, it) => {
        acc.set(it.fontFamily, it.displayName);
        return acc;
      }, new Map());
  }

  return allFontsFamilyNameToDisplayNameMap;
}
